<template>
  <div>
    <v-row
      v-if="!loading" 
      class="ma-0" 
      :class="{ 'pa-0': $vuetify.breakpoint.smAndUp }">

      <v-app-bar class="color-app-bar" app dark>
        <v-toolbar-title> 
          <b><b>JIJE</b></b> UNL
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          class="ma-2"
          outlined
          color="white"
          small
          v-if="$vuetify.breakpoint.smAndUp"
          to="/login">
          Iniciar Sesión
        </v-btn>

        <v-btn
          class="ma-2"
          text
          color="white"
          small
          v-if="!$vuetify.breakpoint.smAndUp"
          to="/login">
          <v-icon
          >
            mdi-login-variant
          </v-icon>
        </v-btn>
      </v-app-bar>

      <section 
        v-if="false" 
        class="convocation-alert text-center d-flex align-center">
        <v-row>
          <v-col cols="12">
            <h1 class="text-h6 white--text" style="font-family: 'Lato'!important;">
              ¡Atención emprendedores, la convocatoria <b>JIJE 2024</b> esta abierta!
            </h1>
          </v-col>
        </v-row>
      </section>

      <!-- Main Section -->
      <section 
        v-if="!loading">
        <v-parallax
          class="index-parallax"
        >
          <div 
            class="parallax-overlay" 
            :style="{ 'background-color': `rgba(0, 0, 0, ${shade_image_main_section})`}" >

          </div>
          <div class="parallax-image-wrapper">
            <img
              class="parallax-image"
              :style="{ 'filter': `blur(${blur_image_main_section}px)` }"
              :src="cover_image_main_section"
              @load="handleImageLoad"
              alt="Background Image"
            >
          </div>
          <v-row
            align="center"
            justify="center"
            style="z-index:2;"
          >
            <v-col
              class="text-center"
              cols="12"
            >
              <h4 
                class="text-subtitle-1 font-weight-thin mb-8" 
                style="font-family: 'Lato'!important; font-size: 62px!important;">
                <b>JIJE</b>UNL
              </h4>
              <h4 class="text-h5 mb-4" style="font-family: 'Lato'!important;">
                {{ slogan_main_section }}
              </h4>
              <div class="container-chevron pt-8">
                <div class="chevron"></div>
                <div class="chevron"></div>
                <div class="chevron"></div>
              </div>
            </v-col>
          </v-row>
        </v-parallax>
      </section>

      <!-- Featured Sponsors -->
      <section 
        v-if="enable_featured_sponsors_landing==1"
        style="background-color: white;">
        <v-row class="d-flex justify-center align-center pl-2 pr-2">

          <cardFeaturedSponsorsLanding
            :types_sponsors="featured_sponsor" 
          />

        </v-row>
      </section>

      <!-- Convocation Active -->
      <section 
        class="convocation-active text-center d-flex align-center"
        v-for="convocation in convocations"
        :key="convocation.id">

        <v-row>
          <v-col cols="12" align="center">
            <h1 class="text-h3 white--text font-weight-thin" style="font-family: 'Lato'!important;">
              ¡Convocatoria <b>{{ convocation.short_name }}!</b>
            </h1>
          
            <p 
              class="white--text subtitle-1 pt-6 container">
              La {{ convocation.name }} se encuentra abierta a los emprendedores 
              desde las {{ convocation.start_time_entrepreneurs }} del {{ formattedDate(convocation.start_date_entrepreneurs) }}
              hasta las {{ convocation.finish_time_entrepreneurs }} del {{ formattedDate(convocation.finish_date_entrepreneurs) }}
            
            </p>

            <p 
              class="white--text overline">
              Faltan
            </p>

            <Countdown 
              class="white--text font-weight-light"
              :style="countdownStyle"
              :date="formattedDateCountDown(convocation.finish_date_entrepreneurs, convocation.finish_time_entrepreneurs)">
            </Countdown>

          </v-col>

          <v-col cols="12">
            <v-btn
              class="glow-on-hover2"
              x-large
              outlined
              dark
              :to="{ name: 'PostulateProject', params: { slug: convocation.slug } }">

              Postular mi proyecto
            </v-btn>
          </v-col>
        </v-row>

      </section>
      
      <!-- Register/login -->
      <section
        v-if="enable_auth_section"
        class="d-flex align-center justify-center section-register pt-8 pb-8">
        <v-row class="content pa-8">

          <v-card
            class="mx-auto mb-8"
            max-width="340"
            style="zoom: .9;"
            outlined>
            <v-row :style="{ height: height_assistant_card + 'px' }">
              <v-col cols="12" class="pt-8 text-center">
                <v-img 
                  :src="require('@/assets/icons/register_icon.png')"
                  height="72"
                  contain
                />
              </v-col>

              <v-col 
                cols="12" 
                class="text-body-1 text-center pl-8 pr-8">
                <div v-html="text_assistant_card"></div>
              </v-col>
            </v-row>

            <v-divider class="mt-8"></v-divider>

            <v-card-actions>
              <v-btn
                class="pa-2"
                block
                x-large
                dark
                color="#009bb4"
                :to="{ name: 'RegisterParticipant', params: { slug: data.last_edition.slug }}">
                Registrarme como asistente
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card
            class="mx-auto mb-8"
            max-width="340"
            style="zoom: .9;"
            outlined>
            <v-row :style="{ height: height_user_card + 'px' }">
              <v-col cols="12" class="pt-8 text-center">
                <v-img 
                  :src="require('@/assets/icons/login_icon.png')"
                  height="72"
                  contain
                />
              </v-col>

              <v-col 
                cols="12" 
                class="text-body-1 text-center pl-8 pr-8">
                <div v-html="text_user_card"></div>
              </v-col>
            </v-row>

            <v-divider class="mt-8"></v-divider>

            <v-card-actions>
              <v-btn
                class="pa-2"
                block
                x-large
                dark
                color="#009bb4"
                to="/login">
                Iniciar Sesión
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-row>
      </section>

      <!-- JIJE in data -->
      <section 
        v-if="enable_indicators_section_landing"
        class="d-flex justify-center pt-8 pb-8" 
        >
        <v-row class="container d-flex justify-center align-center">
          <h2>{{ title_indicators }}</h2>
        </v-row>

        <v-row class="container d-flex justify-center align-start">
          <v-col 
            cols="12" 
            xl="3" 
            md="3" 
            sm="6"
            xs="12"
            class="text-center"
            v-for="(indicator, index) in indicators" 
            :key="index">

            <v-img 
              :src="indicator.image"
              height="72"
              contain
            />

            <h1 
              class="mt-2"
              style="font-size:42px;">
              +{{ indicator.number }}
            </h1>

            <h4
              class="text--secondary mt-2" 
              style="font-size:22px;">
              {{ indicator.title }}
            </h4>

          </v-col>
        </v-row>
      </section>

      <!-- Text Landing -->
      <section 
        v-if="enable_text_landing"
        class="d-flex justify-center pt-8 pb-8 section-register">
        <v-row class="container">
          <div v-html="parsedTextLanding"></div>
        </v-row>
      </section>

      <!-- Featured Entrepreships -->
      <section
        v-if="enable_featured_projects_landing"
        class="d-flex justify-center pt-8 pb-8" 
        style="background-color:#ffffff;">
        <v-row class="container d-flex justify-center align-center">
          <h2>{{ title_featured_projects }}</h2>
        </v-row>

        <v-row class="container d-flex justify-center align-center">
          <div 
            class="item tall"
            v-for="item in featured_projects"
            :key="item.id">
            <div class="card">
              <v-img
                class="image-card"
                v-bind:src="item.logo"
                height="180px"
                max-width="100%"
                cover
              >
              </v-img>
              <div class="card-details">
                <div class="overline text--secondary" style="margin-top: -14px;">{{ item.edition_name }}</div>
                <div class="text-title">{{ item.title }}</div>
                <div class="text-subtitle text--secondary">{{ item.type_postulation_name }}</div>
              </div>
              <button class="card-button">
                <v-icon
                  dark
                  right
                >
                  mdi-heart
                </v-icon>
                  {{ item.likes }}
              </button>

            </div>
          </div>
        </v-row>
      </section>

      <!-- Contact -->
      <v-btn
        fab
        fixed
        bottom
        right
        dark
        x-large
        class="mb-8 mr-8"
        color="#0DC143"
        v-if="enable_contact_section_landing"
        @click="openWhatsApp"
      >
        <v-icon>mdi-whatsapp</v-icon>
      </v-btn>

    </v-row>

    <v-row v-if="loading">
      <v-col 
        style="background-color: white; height: 110vh; z-index: 10;">
        <div class="spinner"></div>
      </v-col>
    </v-row>

  </div>
</template>

<script>
const APP_URL = process.env.VUE_APP_URL
import { mapGetters } from 'vuex'
import axios from 'axios'
import cardFeaturedSponsorsLanding from '@/components/card/cardFeaturedSponsorsLanding.vue'

import Countdown from "@/components/Countdown";

export default {
  name: 'index',
  components: {
    cardFeaturedSponsorsLanding,
    Countdown
  },
  data: () => ({
    width_card:380,
    loading:true,
    loading_sponsors:false,
    show_featured_sponsors:true,

    cover_image_main_section: null,
    shade_image_main_section: 0,
    blur_image_main_section: 0,
    slogan_main_section: null,

    enable_featured_sponsors_landing: false,

    enable_auth_section: false,
    height_assistant_card: 320,
    text_assistant_card: null,
    height_user_card: 320,
    text_user_card: null,
    
    enable_text_landing: false,
    text_landing: null,

    enable_indicators_section_landing: false,
    title_indicators: null,
    indicators: [],

    enable_featured_projects_landing: false,
    title_featured_projects: null,
    featured_projects:[],

    enable_contact_section_landing: false,
    number_contact_landing: null,
    text_contact_landing: null,

    convocations:[],
    public_access:[],
    featured_sponsor:[],

    data:[],
    nada:'hola tomas',
    options: ['index', 'register_participant', 'postulate_project'],
    option_selected: 'index',
    edition_selected: null
  }),
  computed: {
    ...mapGetters([
      'user', 'isLogged'
    ]),
    countdownStyle() {
      return {
        zoom: this.$vuetify.breakpoint.xs ? '90%' : '140%'
      };
    },
    parsedTextLanding() {
      return this.text_landing
        .replace(/ql-align-center/g, 'text-center')
        .replace(/ql-align-right/g, 'text-right')
        .replace(/ql-align-left/g, 'text-left')
        .replace(/ql-align-justify/g, 'text-justify');
    }
  },
  methods: {
    async getInfoLanding(){
      await axios.get('landing-page').then(response =>{
        this.data = response.data.data

        this.cover_image_main_section = APP_URL + this.data.landing.cover_image_main_section
        this.shade_image_main_section = this.data.landing.shade_image_main_section
        this.blur_image_main_section = this.data.landing.blur_image_main_section
        this.slogan_main_section = this.data.landing.slogan_main_section
        
        this.enable_featured_sponsors_landing = (this.data.landing.enable_featured_sponsors_landing==1)?true:false
        this.type_featured_sponsors = this.data.landing.type_featured_sponsors

        this.enable_auth_section = (this.data.landing.enable_auth_section==1)?true:false
        this.height_assistant_card = this.data.landing.height_assistant_card
        this.text_assistant_card = this.data.landing.text_assistant_card
        this.height_user_card = this.data.landing.height_user_card
        this.text_user_card = this.data.landing.text_user_card

        this.enable_text_landing = (this.data.landing.enable_text_landing==1)?true:false
        this.text_landing = this.data.landing.text_landing

        this.enable_indicators_section_landing = (this.data.landing.enable_indicators_section_landing==1)?true:false
        this.title_indicators = this.data.landing.title_indicators
        this.indicators = this.data.landing.indicators

        this.indicators.forEach(element => {
          element.image = APP_URL + element.image
        });

        this.enable_featured_projects_landing = (this.data.landing.enable_featured_projects_landing==1)?true:false
        this.title_featured_projects = this.data.landing.title_featured_projects
        this.featured_projects = response.data.data.featured_projects

        this.featured_projects.forEach(element => {
          element.logo= APP_URL + element.logo
        });

        this.enable_contact_section_landing = (this.data.landing.enable_contact_section_landing==1)?true:false
        this.number_contact_landing = this.data.landing.number_contact_landing
        this.text_contact_landing = (this.data.landing.text_contact_landing!=null)?this.data.landing.text_contact_landing:''

        this.convocations = response.data.data.convocations
      }).catch(error => {
        console.log(error)
      })
    },

    async getFeaturedSponsor(){
      await axios.get('featured-sponsors').then(response =>{
        console.log(response)
        this.featured_sponsor = response.data.data.featured_sponsor
      }).catch(error => {
        console.log(error);
      })
    },

    formattedDate(date) {
      // Dividir la cadena en partes de año, mes y día
      const [year, month, day] = date.split('-');

      // Concatenar en el formato deseado
      return `${day}/${month}/${year}`;
    },

    formattedDateCountDown(finish_date_entrepreneurs, finish_time_entrepreneurs){
      let aux = finish_date_entrepreneurs+'T'+finish_time_entrepreneurs
      return new Date(aux)
    },

    openWhatsApp() {
      const number = this.number_contact_landing;
      const message = this.text_contact_landing ? encodeURIComponent(this.text_contact_landing) : '';
      const url = message ? `https://wa.me/${number}?text=${message}` : `https://wa.me/${number}`;

      window.open(url, '_blank');
    },

    handleImageLoad() {
      // Este método se llama cuando la imagen ha terminado de cargar
      this.loading = false; // Cambia el estado de loading a false
    }
  },
  created(){
    Promise.all([
      this.getFeaturedSponsor(),
      this.getInfoLanding()
    ]).then(() => {
      this.handleImageLoad()
    }).catch((error) => {
      console.log(error)
    });
  }
};
</script>
<style scoped>
.index-parallax {
  margin-top: 0px;
  margin-left: 0px;
  position: relative;
  min-height: 97vh;
  width: 100vw;
  border-bottom: 5px solid #00a1b8;
}

.parallax-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
/*   background-color: rgba(0, 0, 0, 0.25); Color negro semi-transparente */
  z-index: 0; /* Coloca la capa detrás del contenido */
}

.parallax-image-wrapper{
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  overflow: hidden;
  z-index: -1; /* Asegura que la imagen esté detrás del contenido */
}

.parallax-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* filter: blur(3px); /* Aplica el desenfoque */
}

.index-parallax .v-row,
.index-parallax .v-col {
  position: relative;
  z-index: 2;
  color: white; /* Asegura que el texto sea visible */
}

.convocation-alert{
  margin-top: 62px;
  min-height: 48px;
  background-color: red;
}

.convocation-active {
  min-height: calc(100vh - 64px);
  background-image: linear-gradient(to right top, #ff0000, #ff0046, #f1007f, #b900ba, #1218eb);
}

.card-index{
  padding-top: 20vh;
  padding-bottom: 20vh;
}

@media (max-width: 600px) {
  .centered {
    position: absolute;
    top: 60vh;
    left: 50%;
    width: 100vw;
    transform: translate(-50%, -50%);
  }

  .image-landing{
    left: 50%;
    right: 50%;
    margin-top: -50vh;
    margin-bottom: -150px;
    margin-left: -50vw;
    margin-right: -50vw;
    max-width: 100vw;
    position: relative;
    width: 100vw;
    border-bottom: 5px solid #00a1b8;
    filter: brightness(50%);
  }
}
/* Estilos para pantallas medianas (viewport entre 601px y 992px) */
@media (min-width: 601px) {
  .centered {
    position: absolute;
    top: 24rem;
    left: 70%;
    transform: translate(-50%, -14rem);
  }

  .image-landing{
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    max-width: 100vw;
    position: relative;
    width: 100vw;
    border-bottom: 5px solid #00a1b8;
    filter: brightness(50%);
  }
}

.container-chevron{
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
  }
    
  .chevron {
    position: absolute;
    padding-bottom:5px;
    width: 48px;
    height: 8px;
    opacity: 0;
    transform: scale3d(0.5, 0.5, 0.5);
    animation: move 3s ease-out infinite;
  }

  .chevron:first-child {
    animation: move 3s ease-out 1s infinite;
  }

  .chevron:nth-child(2) {
    animation: move 3s ease-out 2s infinite;
  }

  .chevron:before,
  .chevron:after {
    content: ' ';
    position: absolute;
    top: 0;
    height: 100%;
    width: 51%;
    background: #fff;
  }

  .chevron:before {
    left: 0;
    transform: skew(0deg, 30deg);
  }

  .chevron:after {
    right: 0;
    width: 50%;
    transform: skew(0deg, -30deg);
  }

  @keyframes move {
    25% {
      opacity: 1;

    }
    33% {
      opacity: 1;
      transform: translateY(30px);
    }
    67% {
      opacity: 1;
      transform: translateY(40px);
    }
    100% {
      opacity: 0;
      transform: translateY(55px) scale3d(0.5, 0.5, 0.5);
    }
  }

.glow-on-hover {
  width: 320px;
  height: 62px!important;
  outline: none;
  color: #fff;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 10px;
}

.glow-on-hover:before {
    content: '';
    background: linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000);
    position: absolute;
    top: -2px;
    left:-2px;
    background-size: 400%;
    z-index: -1;
    filter: blur(5px);
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    animation: glowing 20s linear infinite;
    opacity: 0;
    transition: opacity .3s ease-in-out;
    border-radius: 10px;
}

.glow-on-hover:active {
    color: #000
}

.glow-on-hover:active:after {
    background: transparent;
}

.glow-on-hover:hover:before {
    opacity: .4;
}

.glow-on-hover:after {
    z-index: -1;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: #00000077;
    left: 0;
    top: 0;
    border-radius: 10px;
}

@keyframes glowing {
    0% { background-position: 0 0; }
    50% { background-position: 400% 0; }
    100% { background-position: 0 0; }
}

.section-register{
  background-color: #F7F8F9;
}

.spinner {
  height:60px;
  width:60px;
  position: absolute;
  top:45%;
  left:50%;
  margin: -(60/2) 0 0 -(60/2);
  -webkit-animation: rotation 1s infinite linear;
  -moz-animation: rotation 1s infinite linear;
  -o-animation: rotation 1s infinite linear;
  animation: rotation 1s infinite linear;
  border:6px solid rgba(0,0,0,.2);
  border-radius:100%;
}

.spinner:before {
  content:"";
  display:block;
  position:absolute;
  left:-6px;
  top:-6px;
  height:100%;
  width:100%;
  border-top:6px solid rgba(0,0,0,.8);
  border-left:6px solid transparent;
  border-bottom:6px solid transparent;
  border-right:6px solid transparent;
  border-radius:100%;
}

@-webkit-keyframes rotation {
  from {-webkit-transform: rotate(0deg);}
  to {-webkit-transform: rotate(359deg);}
}
@-moz-keyframes rotation {
  from {-moz-transform: rotate(0deg);}
  to {-moz-transform: rotate(359deg);}
}
@-o-keyframes rotation {
  from {-o-transform: rotate(0deg);}
  to {-o-transform: rotate(359deg);}
}
@keyframes rotation {
  from {transform: rotate(0deg);}
  to {transform: rotate(359deg);}
}



section {
  display: flex;
  flex-wrap: wrap; /* Permite que los elementos se envuelvan a la siguiente fila */
  justify-content: center; /* Centra los elementos horizontalmente */
  width: 100vw;
  margin-top: 20px;
}

.tall {
  width: 264px;
}

img {
  display: block;
}

.divider {
  width: 8px;
  height: auto; /* Permite que el divisor se ajuste a la altura del contenido */
  background: blue;
}

.item {
  flex: 0 1 auto;
  background: none;
}

.card {
  width: 240px;
  height: 320px;
  margin-bottom: 28px;
  border-radius: 8px;
  background: #ffffff;
  position: relative;
  padding: 0rem;
  border: 2px solid #c3c6ce;
  transition: 0.5s ease-out;
  overflow: visible;
}

.image-card {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden; 
}

.card-details {
  padding: 14px;
  place-content: center;
}

.card-button {
  transform: translate(-50%, 125%);
  width: 50%;
  border-radius: 8px;
  border: none;
  cursor: default;
  background-color: #008bf8;
  color: #fff;
  font-size: 1rem;
  padding: .3rem .7rem;
  position: absolute;
  left: 50%;
  bottom: 0;
  opacity: 0;
  transition: 0.3s ease-out;
}

.text-body {
  color: rgb(134, 134, 134);
}

.text-title {
  font-size: 1.2em;
  font-weight: bold;
  margin-top: -6px;
  display: -webkit-box; /* Fallback for older browsers */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2; /* Número de líneas que quieres mostrar */
  line-clamp: 2; /* Estándar, aunque no está ampliamente soportada aún */
  line-height: 1.2em; /* Ajusta esta propiedad según el espacio entre líneas */
  max-height: 2.4em; /* 2 * line-height, ajusta según corresponda */
}

.text-subtitle {
  font-size: .9em;
  margin-top: 2px;
  font-weight: light;
}

.card:hover {
  border-color: #008bf8;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.25);
}

.card:hover .card-button {
  transform: translate(-50%, 50%);
  opacity: 1;
}


/* Animation */
@keyframes fadeInUp {
  from {
      transform: translate3d(0,40px,0)
  }

  to {
      transform: translate3d(0,0,0);
      opacity: 1
  }
}

@-webkit-keyframes fadeInUp {
  from {
      transform: translate3d(0,40px,0)
  }

  to {
      transform: translate3d(0,0,0);
      opacity: 1
  }
}

.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: both
}

.animatedFadeInUp {
  opacity: 0
}

.fadeInUp {
  opacity: 0;
  animation-name: fadeInUp;
  -webkit-animation-name: fadeInUp;
}
</style>